import React, { FC } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import PopupResult, { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';

interface IPopupResponseProps {
    isOpen: boolean,
    type: EResultPopupStatus,
    title: string,
    text?: string,
    onClose: () => void,
}

const PopupResponse: FC<IPopupResponseProps> = ({ isOpen, type, title, text, onClose }) => {

    return (
        <PopupResult
            isOpen={isOpen}
            type={type}
            title={title}
            text={text}
            onClose={onClose}
        >
            <Button
                onClick={onClose}
                bType='accent'
            >
                Закрыть
            </Button>
        </PopupResult>
    );
};

export default PopupResponse;
